import AppRoutes from './appRoutes';

import { useRoutes } from 'react-router-dom';

const Routes = () => {
    return useRoutes([AppRoutes]);
};

export default Routes;
